module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.titleType,
      "visible": _vm.brandVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.brandVisible = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "dialogForm",
    attrs: {
      "label-width": "100px"
    }
  }, [(_vm.brandVisible) ? _c('el-form-item', {
    attrs: {
      "label": "所属品牌:"
    }
  }, [(_vm.readOnlyBrandYesDropDown) ? _c('el-cascader', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "options": _vm.options,
      "placeholder": "请选择",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readOnlyBrandNoDropDown) ? _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.modelStoresName),
      callback: function($$v) {
        _vm.modelStoresName = $$v
      },
      expression: "modelStoresName"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "preservation_div"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.brandVisible = false
      }
    }
  }, [_vm._v(" 取消 ")]), _vm._v(" "), (_vm.titleType == '新增合作品牌') ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v(" 确认 ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-666af20f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/userManagement/addCooperativeBrand.vue
// module id = 1707
// module chunks = 3